import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Nav from './components/Nav';
import Hero from './components/Hero';
import WhatSection from './components/WhatSection';
import HistorySection from './components/HistorySection';
import SignatureDevice from './components/SignatureDevice';
import LocationSection from './components/LocationSection';
import MailingList from './components/MailingList';
import BookSection from './components/BookSection';
import Banner from './components/Banner';
import ContentGuidance from './components/ContentGuidance';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import TrailerModal from './components/TrailerModal';
import PressPage from './pages/PressPage';
import { BOOK } from './data/mock';

const Home = () => {
  const bookRef = useRef(null);
  const [trailerOpen, setTrailerOpen] = useState(false);
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
    return () => clearTimeout(t);
  }, [hash]);

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const scrollToBook = () => scrollToId('book');
  const heroCta = () => scrollToId(BOOK.soldOut ? 'waitlist' : 'book');

  return (
    <>
      <Nav onBookClick={scrollToBook} />
      <main>
        <Hero onBookClick={heroCta} onWatchClick={() => setTrailerOpen(true)} />
        <WhatSection />
        <Banner />
        <HistorySection />
        <SignatureDevice />
        <LocationSection />
        <MailingList />
        <BookSection ref={bookRef} />
        <ContentGuidance />
        <Testimonials />
      </main>
      <Footer />
      <TrailerModal
        open={trailerOpen}
        onClose={() => setTrailerOpen(false)}
        onBookClick={scrollToBook}
      />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/press" element={<PressPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
